import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {getModelForResourceType} from 'resources/modelRegistry';
import {renderMoment} from 'lib/timeUtils';
import {pluralize} from 'lib/stringUtils';
import {Button, Text} from '@albert-io/atomic';
import StagingDetails from 'client/components/PracticeView/StagingDetails/StagingDetails.react';

export default class FolderDetails extends React.Component {
  static propTypes = {
    folder: PropTypes.instanceOf(getModelForResourceType('template_v1')),
    toggleFolderDetails: PropTypes.func,
    subjects: ImmutablePropTypes.set
  };

  getLastModified = () => {
    const {folder} = this.props;
    // We need to check both values due to `getUpdatedAt` not accounting for reordering
    const lastUpdatedFolderQuestionSets = folder.getMeta().getQuestionSetRelationshipUpdatedAt();
    const lastUpdatedFolderDetails = folder.getUpdatedAt();
    const mostRecentUpdate = moment(lastUpdatedFolderQuestionSets).isAfter(lastUpdatedFolderDetails)
      ? lastUpdatedFolderQuestionSets
      : lastUpdatedFolderDetails;
    const date = renderMoment(mostRecentUpdate, 'dateFormal');
    const time = renderMoment(mostRecentUpdate, 'time');
    return `${date} at ${time}`;
  };

  getSubjects = () => {
    return (
      <ul className='u-list-style_none u-pad_0'>
        {this.props.subjects.map((subject, i) => (
          <Text className='u-mar-b_1' key={i} emphasis='lowest' size='s' as='li'>
            {subject.getName()}
          </Text>
        ))}
      </ul>
    );
  };

  render() {
    const {folder, toggleFolderDetails} = this.props;
    return (
      <StagingDetails
        sideBarImageWidth='125px'
        sidebarImage={import('client/components/PracticeView/StagingDetails/folder-open.svg')}
      >
        <StagingDetails.Header
          title={folder.getName()}
          subtitle={`Owned by ${folder.getMeta().getTeacherSalutation() ||
            ''} ${folder.getMeta().getTeacherLastName()}`}
        />
        <StagingDetails.Body>
          <StagingDetails.Item
            icon={['far', 'clock']}
            label='Last Modified'
            details={this.getLastModified()}
          />
          <StagingDetails.Item
            icon={['far', 'question']}
            label='Content'
            details={`${folder.getTotalQuestions()} ${pluralize(
              'question',
              folder.getTotalQuestions()
            )}`}
          />
          <StagingDetails.Item
            icon={['far', 'books']}
            label='Subjects'
            details={this.getSubjects()}
          />
        </StagingDetails.Body>
        <StagingDetails.Footer justifyContent='flex-end'>
          <Button onClick={toggleFolderDetails}>View questions</Button>
        </StagingDetails.Footer>
      </StagingDetails>
    );
  }
}
